import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { DatabaseUnit } from '../../../shared/domain/units/types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/units/all' }

type Params = never
type Body = never
type Query = { editedAfter?: Date; editedBefore?: Date; unitType?: number[] | number }
export type Output = {
    units: Array<
        Omit<DatabaseUnit, 'name'> & { children: number[]; parents: number[]; unitName: string; unitTypeName: string }
    >
}

export type GetEndpoint = Endpoint<Params, Body, Query, Output>

export const get = (request: Request, args: RequestArgs<GetEndpoint>) => request<GetEndpoint>(route, args)
